import React, {Component} from "react";
import TopNav from "../../common/nav/TopNav";
import Footer from "../../common/Footer";
import PageBlock from "../../common/PageBlock";
import CoreService from "../../service/CoreService";
import {Link} from "react-router";
import MocksStatusService from "../../service/MocksStatusService";
import './Mock.css';
import {defaultTenantId} from "../../service/TenantService";
import SubscriptionService from "../../service/SubscriptionService";
import MocksConfigService from "../../service/MocksConfigService";

class Mocks extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mocks: null,
        };
    }

    fetchMocks = () => {
        const self = this;

        MocksStatusService.fetchMocks((mocks, err) => {
            if (err) {
                CoreService.showPassiveError("Sorry, we can't fetch the status of your mocks right now.");
                return;
            }

            // always put default first
            mocks.sort((m1, m2) => m1.mockId === defaultTenantId ? -1 : m2.mockId === defaultTenantId ? 1 : 0);

            const mockRows = [];
            let rowId = 0;
            mocks.forEach((mock) => {
                let iconName;
                let iconColour;
                switch (mock.status) {
                    case 'DRAFT':
                        iconName = 'new-message';
                        break;
                    case 'UPDATING':
                        iconName = 'cw';
                        break;
                    case 'ACTIVE':
                        iconName = 'controller-record';
                        iconColour = 'green';
                        break;
                    case 'RETIRED':
                    case 'INACTIVE':
                        iconName = 'controller-stop';
                        iconColour = 'grey';
                        break;
                    case 'FAILED':
                        iconName = 'warning';
                        iconColour = 'yellow';
                        break;
                    default:
                        iconName = 'help-with-circle';
                        break;
                }
                mockRows.push(
                    <tr key={rowId++}>
                        <td><i className={`small icon icon-${iconName}`}  style={{color: iconColour}}/></td>
                        <td>{mock.mockId}</td>
                        <td>{mock.status}</td>
                        <td><Link to={`/mocks/${mock.mockId}`}><i className="small icon icon-chevron-with-circle-right m-r-xs"/>View</Link></td>
                    </tr>
                )
            });

            self.setState({mocks: mockRows});
        });
    }

    createMock = () => {
        SubscriptionService.doIfSubscriptionActive(() => {
            MocksConfigService.createMock((mockId) => {
                CoreService.navigateTo(`/mocks/${mockId}`);
            });
        });
    }

    componentDidMount() {
        this.fetchMocks();
    }

    render() {
        return (
            <div>
                <TopNav tab="mocks"/>

                <PageBlock>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">API Mocks</h1>
                                <h4 className="text-muted">Interactive mocks for OpenAPI, REST and SOAP/WSDL.</h4>
                            </div>
                        </div>

                        <div className="row m-b-sm">
                            <div className="col-lg-12">
                                <p>Upload OpenAPI specification files to create an interactive mock API.</p>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-10 col-md-8 col-lg-8">
                                <div className="panel panel-info">
                                    <div className="panel-heading">
                                        <h3 className="panel-title">Mocks
                                            <button type="button" className="btn btn-xs btn-default btn-borderless pull-right"
                                                    onClick={this.fetchMocks}><i className="icon icon-cycle m-r-xs"/>Refresh
                                            </button>
                                        </h3>
                                    </div>
                                    <div className="panel-body">
                                        {this.state.mocks === null &&
                                            <div className="text-muted">Fetching mocks...</div>}

                                        {this.state.mocks && this.state.mocks.length === 0 &&
                                            <div className="text-muted">No mocks.</div>}

                                        {this.state.mocks && this.state.mocks.length > 0 &&
                                            <table className="table table-striped">
                                                <thead>
                                                <tr>
                                                    <th colSpan={2}>Mock</th>
                                                    <th>Status</th>
                                                    <th>Actions</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {this.state.mocks}
                                                </tbody>
                                            </table>}

                                        <hr/>
                                        <h5>Add a new mock</h5>
                                        <div className="row">
                                            <div className="col-xs-12">
                                                <p>Each mock has its own unique endpoint, behaviour and APIs.</p>
                                                <button className="btn btn-primary" onClick={() => this.createMock()}>Add mock</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Tip */}
                            <div className="col-sm-10 col-md-4">
                                <div className="callout m-t-0 m-b-sm">
                                    <div className="callout-content">
                                        <strong>Need some inspiration?</strong><br/>Learn more about mock specifications and script files.
                                    </div>
                                    <div className="callout-secondary">
                                        <Link to="/docs" className="btn btn-sm btn-info secondary-fixed-width-btn">Learn more</Link>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default Mocks;



// WEBPACK FOOTER //
// ./src/modules/views/mocks/Mocks.js